import PropTypes from 'prop-types';
import '../../../styles/reports.css';
import React from 'react';
import { generateTableRows } from './generateTableRows';
import { generateTableHeaders } from './generateTableHeaders';

const TotalsTable = ({
  data,
  persistData,
  colSpan
}) => {

  return (
    <div id='growthTable' className='mt-4 table-responsive growth-table-scroll-bar'>
      <table className='w-100 text-center growth-table'>
        <thead>
          <tr>
            <th rowSpan={2} className='border'></th>
            <th rowSpan={2} className='border'>Pre-Test<br />Max Points</th>
            {persistData.midTestID > 0 &&
              <th rowSpan={2} className='border'>Mid-Test<br />Max Points</th>
            }
            <th rowSpan={4} className='border'>Post-Test<br />Max Points</th>

            {persistData.studentID > 0 &&
              <th colSpan={colSpan} className='bg-student-header border'>Student</th>
            }
            {persistData.classID > 0 &&
              <th colSpan={colSpan} className='bg-class-header border'>Class</th>
            }
            {persistData.teacherID > 0 &&
              <th colSpan={colSpan} className='bg-teacher-header border'>Teacher</th>
            }
            {persistData.schoolID > 0 &&
              <th colSpan={colSpan} className='bg-school-header border'>School</th>
            }
            {persistData.districtID > 0 &&
              <th colSpan={colSpan} className='bg-district-header border'>District</th>
            }
          </tr>
          <tr>
            {persistData.studentID > 0 &&
              generateTableHeaders('bg-student-header', persistData.growth, persistData.midTestID > 0)
            }
            {persistData.classID > 0 &&
              generateTableHeaders('bg-class-header', persistData.growth, persistData.midTestID > 0)
            }
            {persistData.teacherID > 0 &&
              generateTableHeaders('bg-teacher-header', persistData.growth, persistData.midTestID > 0)
            }
            {persistData.schoolID > 0 &&
              generateTableHeaders('bg-school-header', persistData.growth, persistData.midTestID > 0)
            }
            {persistData.districtID > 0 &&
              generateTableHeaders('bg-district-header', persistData.growth, persistData.midTestID > 0)
            }
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => {
            var thresholdValue = item.scoreType == 'points' ? persistData.thresholdPoints : persistData.thresholdPercent;
            var isPercent = item.scoreType == 'points' ? false : true;
            return (
              <React.Fragment key={index}>
                {((persistData.points && item.scoreType == 'points') || (persistData.percentage && item.scoreType == 'percentage')) &&
                <tr>
                  <td className='border'>{item.scoreType === 'points' ? (<>Total<br />(Points)</>) : (<>Total<br />(Percentage)</>)}</td>
                  <td className='border'>{item.preTestMaxPoints}</td>
                  {persistData.midTestID > 0 &&
                    <td className='border'>{item.midTestMaxPoints}</td>
                  }
                  <td className='border'>{item.postTestMaxPoints}</td>
                  {persistData.studentID > 0 &&
                    generateTableRows(`${item.scoreType == 'points' ? 'bg-student-points' : 'bg-student-percentage'}`, item.studentGrowth, thresholdValue, persistData.growth, persistData.midTestID > 0, isPercent)
                  }
                  {persistData.classID > 0 &&
                    generateTableRows(`${item.scoreType == 'points' ? 'bg-class-points' : 'bg-class-percentage'}`, item.classGrowth, thresholdValue, persistData.growth, persistData.midTestID > 0, isPercent)
                  }
                  {persistData.teacherID > 0 &&
                    generateTableRows(`${item.scoreType == 'points' ? 'bg-teacher-points' : 'bg-teacher-percentage'}`, item.teacherGrowth, thresholdValue, persistData.growth, persistData.midTestID > 0, isPercent)
                  }
                  {persistData.schoolID > 0 &&
                    generateTableRows(`${item.scoreType == 'points' ? 'bg-school-points' : 'bg-school-percentage'}`, item.schoolGrowth, thresholdValue, persistData.growth, persistData.midTestID > 0, isPercent)
                  }
                  {persistData.districtID > 0 &&
                    generateTableRows(`${item.scoreType == 'points' ? 'bg-district-points' : 'bg-district-percentage'}`, item.districtGrowth, thresholdValue, persistData.growth, persistData.midTestID > 0, isPercent)
                  }
                </tr>
                }
              </React.Fragment>
            );
          })}

        </tbody>
      </table>
    </div>
  );
};

TotalsTable.propTypes = {
  data: PropTypes.array,
  persistData: PropTypes.object,
  colSpan: PropTypes.number
};

export default TotalsTable;